import React, { useState, useEffect } from 'react';
import { quotesApi } from '../../services/api';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { 
  FileText, 
  Loader2,
  ArrowRight
} from 'lucide-react';
import { formatDate, formatCurrency } from '../../lib/utils';

const UserQuotes = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadQuotes();
  }, []);

  const loadQuotes = async () => {
    try {
      const response = await quotesApi.getAll();
      setQuotes(response.data);
    } catch (err) {
      console.error('Failed to load quotes:', err);
    } finally {
      setLoading(false);
    }
  };

  const isQuoteValid = (validUntil) => {
    return new Date(validUntil) > new Date();
  };

  return (
    <div className="space-y-6" data-testid="user-quotes">
      <div>
        <h1 className="font-heading text-2xl md:text-[32px] sv-display">Quotes</h1>
        <p className="text-muted-foreground">View and manage your shipping quotes</p>
      </div>

      <Card>
        <CardContent className="p-0">
          {loading ? (
            <div className="flex items-center justify-center py-16">
              <Loader2 className="h-8 w-8 animate-spin text-secondary" />
            </div>
          ) : quotes.length > 0 ? (
            <div className="overflow-x-auto">
              <Table data-testid="quotes-table">
                <TableHeader>
                  <TableRow>
                    <TableHead>Quote #</TableHead>
                    <TableHead>Route</TableHead>
                    <TableHead>Container</TableHead>
                    <TableHead>Transit</TableHead>
                    <TableHead>Total price</TableHead>
                    <TableHead>Valid until</TableHead>
                    <TableHead>Status</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {quotes.map((quote) => (
                    <TableRow key={quote.id}>
                      <TableCell className="sv-mono font-medium">{quote.quote_number}</TableCell>
                      <TableCell>
                        <div className="flex items-center gap-2 text-sm">
                          <span>{quote.origin_port.split(',')[0]}</span>
                          <ArrowRight className="h-3 w-3 text-muted-foreground" />
                          <span>{quote.destination_port.split(',')[0]}</span>
                        </div>
                      </TableCell>
                      <TableCell>{quote.container_count}x {quote.container_type}</TableCell>
                      <TableCell>{quote.transit_days} days</TableCell>
                      <TableCell className="font-medium">{formatCurrency(quote.total_price)}</TableCell>
                      <TableCell>{formatDate(quote.valid_until)}</TableCell>
                      <TableCell>
                        <Badge className={isQuoteValid(quote.valid_until) ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}>
                          {isQuoteValid(quote.valid_until) ? 'Valid' : 'Expired'}
                        </Badge>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          ) : (
            <div className="text-center py-16">
              <FileText className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">No quotes yet</p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default UserQuotes;
